import React, { useEffect, useState } from "react";


const Timer = ({ onClick, timer, clearTimer }) => {

	const [ seconds, setSeconds ] =  useState(0);

	useEffect(() => {

		let myInterval = setInterval(() => {
			if (seconds > 0) {
				setSeconds(seconds - 1);
			}
		}, 1000)

		return () => {
			clearInterval(myInterval);
		};

	});

	useEffect(() => {
		if(seconds === 0 && timer) {
			clearTimer();
			setSeconds(300);
		}
	}, [seconds, timer, clearTimer]);

	return (
		<>&nbsp;{seconds === 0 && !timer ? null : <span>Send again available in {seconds < 10 ?  `0${seconds}` : seconds} seconds</span>}
			<span>
				{seconds === 0 && !timer && <span style={{ color: "var(--purple6)" }} className="cursor-pointer" onClick={onClick}>Send again</span>}
			</span>
		</>
	)
};

export default Timer;
